// auth.js - Spotify PKCE Authorization

const clientId = '8f7be4126d814e5aa46a34e917e47562';
const redirectUri = 'https://dream.shop/pages/spotify-auth-callback';
const scopes = 'streaming user-read-email user-read-private user-modify-playback-state user-read-playback-state';

function generateRandomString(length) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
}

function base64encode(string) {
  return btoa(String.fromCharCode(...new Uint8Array(string)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

async function generateCodeChallenge(codeVerifier) {
  const data = new TextEncoder().encode(codeVerifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64encode(digest);
}

async function redirectToSpotifyLogin() {
  const codeVerifier = generateRandomString(128);
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  localStorage.setItem('code_verifier', codeVerifier);

  const params = new URLSearchParams({
    response_type: 'code',
    client_id: clientId,
    scope: scopes,
    redirect_uri: redirectUri,
    code_challenge_method: 'S256',
    code_challenge: codeChallenge
  });

  window.location = `https://accounts.spotify.com/authorize?${params.toString()}`;
}

async function fetchAccessToken(code) {
  const codeVerifier = localStorage.getItem('code_verifier');
  const body = new URLSearchParams({
    grant_type: 'authorization_code',
    code,
    redirect_uri: redirectUri,
    client_id: clientId,
    code_verifier: codeVerifier
  });

  const response = await fetch('https://accounts.spotify.com/api/token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body
  });

  const data = await response.json();
  if (data.access_token) {
    localStorage.setItem('access_token', data.access_token);
    return data.access_token;
  }
  console.warn('Token exchange failed:', data);
  return null;
}

async function getAccessToken() {
  const urlParams = new URLSearchParams(window.location.search);

  // Check for authorization code
  if (urlParams.has('code')) {
    const code = urlParams.get('code');
    console.log("code="+code);
    return await fetchAccessToken(code);
  }

  // Check for existing access token
  const token = localStorage.getItem('access_token');
  console.log("token="+token);
  if (token) {
    try {
      // Validate token with a safe API call
      const valid = await fetch('https://api.spotify.com/v1/me', {
        headers: { Authorization: `Bearer ${token}` }
      }).then(r => r.status !== 401).catch(() => false);
      if (valid) return token;
    }
    catch(e){}
  }
  // If invalid or missing, clear and retry
  localStorage.removeItem('access_token');
  localStorage.removeItem('code_verifier');
  redirectToSpotifyLogin();
  return null;
}

window.spotifyAuth = {
  getAccessToken,
  redirectToSpotifyLogin
};